import { Backdrop, CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "./AppContext";
import OpeningCreateDialog from "./pages/POSEntry/OpeningCreateDialog";
import { useSearchPOSOpening } from "./shared/hooks/usePOSData";
import { useGetLoggedUser } from "./shared/hooks/useUser";

const AppInitializer = ({ children }) => {
    const {
        globalState,
        setGlobalState,
        multipleCompanies,
        company,
        settingsDetails,
    } = useContext(AppContext);

    const isAutoCloseCash = useMemo(() => {
        if (settingsDetails) {
            return settingsDetails?.docs[0]?.auto_cash_close == 1;
        }
        return false;
    }, [settingsDetails?.docs[0]?.auto_cash_close]);


    const { data: userInfo } = useGetLoggedUser(true);
    const isKitchenUser = userInfo?.role_profile_name === "Kitchen";
    const isService = userInfo?.role_profile_name === "Service";
    const isHookah = userInfo?.role_profile_name === "Hookah";

    const { data: todayOpen, refetch: refetchTodayOpen } = useSearchPOSOpening({
        user: userInfo?.name,
    });

    const [openingBalanceDialogOpen, setOpeningBalanceDialogOpen] =
        useState(false);

    const [loading, setLoading] = useState(true);

    //    here
    useMemo(() => {
        console.log("todayOpen", todayOpen);
        if (todayOpen) {
            setLoading(false);
        }
        if (todayOpen && todayOpen.length > 0) {
            console.log("multipleCompanies", multipleCompanies);
            if (multipleCompanies) {
                let companyOpenings = todayOpen.filter(
                    (opening) => opening.company === company?.name
                );
                if (companyOpenings && companyOpenings.length > 0) {
                    setOpeningBalanceDialogOpen(false);
                    setLoading(false);
                } else {
                    setOpeningBalanceDialogOpen(true);
                    setLoading(true);
                }
            } else {
                setOpeningBalanceDialogOpen(true);
                setLoading(true);
            }
        } else {
            setOpeningBalanceDialogOpen(true);
            setLoading(true);
        }
    }, [todayOpen]);

    const getLoggedInUser = () => {
        if (userInfo) return userInfo.name;
        else return "";
    };

    useEffect(() => {
        if (!globalState.loggedInUser) {
            setGlobalState({
                ...globalState,
                loggedInUser: getLoggedInUser(),
            });
        }
    }, []);

    return (
        <>
            {isKitchenUser || isService || isHookah || isAutoCloseCash ? (
                <>{children}</>
            ) : loading || !userInfo ? (
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        position: "absolute",
                        backgroundColor: "rgba(33, 43, 54, 0.75)",
                    }}
                    open={true}
                >
                    <CircularProgress />
                    <OpeningCreateDialog
                        dialogOpen={openingBalanceDialogOpen}
                        onConfirm={() => {
                            setOpeningBalanceDialogOpen(false);
                        }}
                    ></OpeningCreateDialog>
                </Backdrop>
            ) : (
                <>{children}</>
            )}
        </>
    );
};

export default AppInitializer;
